import React, { useState, useEffect } from 'react';
import { api } from '@/lib/api';

export default function Invoices() {
    const [invoices, setInvoices] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchInvoices();
    }, []);

    const fetchInvoices = async () => {
        try {
            const response = await api.get('/api/invoices');
            const data = response.data?.data;
            setInvoices(Array.isArray(data) ? data : (data?.items || []));
        } catch (error) {
            console.error('Error fetching invoices:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = (invoice: any) => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) return;
        
        const html = '<html dir="rtl" lang="ar">' +
            '<head>' +
            '<meta charset="UTF-8">' +
            '<title>فاتورة رقم ' + (invoice?.invoiceNumber || '') + '</title>' +
            '<style>' +
            'body { font-family: Tahoma, Arial, sans-serif; padding: 30px; color: #333; }' +
            '.box { border: 1px solid #ccc; padding: 25px; border-radius: 8px; max-width: 700px; margin: 0 auto; }' +
            'h2 { color: #1e3a5f; border-bottom: 2px solid #1e3a5f; padding-bottom: 10px; }' +
            '.details { margin-top: 20px; font-size: 16px; line-height: 1.8; }' +
            '</style>' +
            '</head>' +
            '<body>' +
            '<div class="box">' +
            '<h2>Target Express - تفاصيل الفاتورة</h2>' +
            '<div class="details">' +
            '<p><strong>رقم الفاتورة:</strong> ' + (invoice?.invoiceNumber || '') + '</p>' +
            '<p><strong>اسم العميل:</strong> ' + (invoice?.customerName || 'غير متوفر') + '</p>' +
            '<p><strong>المبلغ الإجمالي:</strong> ' + (invoice?.totalAmount || 0) + ' ر.س</p>' +
            '<p><strong>الحالة:</strong> ' + (invoice?.status || 'مكتملة') + '</p>' +
            '</div>' +
            '</div>' +
            '<script>window.onload = function() { setTimeout(function() { window.print(); window.close(); }, 500); }</script>' +
            '</body>' +
            '</html>';

        printWindow.document.write(html);
        printWindow.document.close();
    };

    return (
        <div className="p-6 max-w-7xl mx-auto">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">إدارة الفواتير</h1>
            </div>

            {loading ? (
                <div className="text-center py-10 text-gray-500">جاري تحميل الفواتير...</div>
            ) : (
                <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">رقم الفاتورة</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">العميل</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">المبلغ</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">الإجراءات</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {invoices.length === 0 ? (
                                <tr>
                                    <td colSpan={4} className="px-6 py-4 text-center text-gray-500">لا توجد فواتير مضافة حالياً</td>
                                </tr>
                            ) : (
                                invoices.map((invoice, index) => (
                                    <tr key={index}>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{invoice.invoiceNumber}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{invoice.customerName}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{invoice.totalAmount} ر.س</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                            <button
                                                onClick={() => handlePrint(invoice)}
                                                className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 px-3 py-1 rounded-md"
                                            >
                                                طباعة
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
